











import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "StoryTimerView",
  props: {
    count: { type: Number, required: true },
    current: { type: Number, required: true },
    percent: { type: Number, required: true },
  },
});
